export const enum AgnosticShipmentSort {
  Status = 'status',
  PickupAsc = 'pickup-asc',
  PickupDesc = 'pickup-desc',
}
